import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "bg-neutral-900" }
const _hoisted_3 = { class: "sm:px-2" }
const _hoisted_4 = { class: "aspect-w-16 aspect-h-9 sm:mt-10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-white p-4" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "text-xs" }
const _hoisted_10 = { class: "flex items-center justify-center" }
const _hoisted_11 = { class: "bg-gray-100" }
const _hoisted_12 = { class: "sm:px-2" }
const _hoisted_13 = { class: "bg-gray-100 p-4 md:py-8" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "px-2" }
const _hoisted_16 = { class: "mb-6" }
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-2" }, " 動画ページが見つかりませんでした。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_details_tag_list = _resolveComponent("video-details-tag-list")!
  const _component_video_details_watch_completion_button = _resolveComponent("video-details-watch-completion-button")!
  const _component_video_details_bookmark_button = _resolveComponent("video-details-bookmark-button")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_video_details_question = _resolveComponent("video-details-question")!
  const _component_video_category_list_content = _resolveComponent("video-category-list-content")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      (_ctx.store.state.video.videoDetails)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_video_details_tag_list, {
              tags: _ctx.store.state.video.videoDetails.tags
            }, null, 8, ["tags"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_layouts_auth_width, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("iframe", {
                          src: _ctx.store.state.video.videoDetails.embed_url,
                          width: "100%",
                          height: "100%",
                          frameborder: "0",
                          allow: "autoplay; fullscreen; picture-in-picture"
                        }, null, 8, _hoisted_5)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.store.state.video.videoDetails.title), 1),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.store.state.video.videoDetails.video_watch_histories_count) + "回視聴・" + _toDisplayString(_ctx.dayjs(_ctx.store.state.video.videoDetails.published_at).format('YYYY-MM-DD')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_video_details_watch_completion_button, {
                              isCompleted: !!(_ctx.toArray(_ctx.store.state.video.videoDetails?.video_watch_completions).length),
                              class: "mr-2"
                            }, null, 8, ["isCompleted"]),
                            _createVNode(_component_video_details_bookmark_button, {
                              isBookmarked: !!(_ctx.toArray(_ctx.store.state.video.videoDetails?.video_bookmarks).length)
                            }, null, 8, ["isBookmarked"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_layouts_auth_width, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "v-html whitespace-pre-wrap",
                          innerHTML: _ctx.store.state.video.videoDetails.body
                        }, null, 8, _hoisted_14)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_layouts_auth_width, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_video_details_question, {
                      videoQuestions: _ctx.store.state.video.videoDetails.video_questions
                    }, null, 8, ["videoQuestions"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_video_category_list_content, {
                      videoCategories: _ctx.videoCategories,
                      allCategoriesLink: true
                    }, null, 8, ["videoCategories"])
                  ])
                ])
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_component_layouts_auth_width, { key: 1 }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}